import React from "react";
import { parseNum } from "./utils";

interface BulkFillBarProps {
    isPastYear: boolean;
    bulkPercent: string;
    handleBulkPercentChange: (value: string) => void;
    handleBulkPercentBlur: () => void;
    focusedInput: number | 'bulk' | null;
    setFocusedInput: (v: number | 'bulk' | null) => void;
    selectedCount: number;
    handleApplyBulkPercent: () => void;
}

export const BulkFillBar: React.FC<BulkFillBarProps> = ({
    isPastYear,
    bulkPercent,
    handleBulkPercentChange,
    handleBulkPercentBlur,
    focusedInput,
    setFocusedInput,
    selectedCount,
    handleApplyBulkPercent,
}) => {
    if (isPastYear) return null;

    const bulkNum = parseNum(bulkPercent);
    const isBulkInvalid = bulkPercent !== "" && (!isNaN(bulkNum) && (bulkNum < 0 || bulkNum > 100));

    return (
        <div style={{ background: "#f0fdfa", border: "1px solid #99f6e4", borderRadius: "12px", padding: "14px 18px", marginBottom: "16px", display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
            <span style={{ fontSize: "12.5px", fontWeight: 700, color: "#0f766e" }}>Preenchimento em lote</span>
            <span style={{ fontSize: "12.5px", color: "#64748b" }}>Aplicar % de reajuste a todos os selecionados:</span>

            <div>
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <div style={{ position: "relative" }}>
                        <input
                            type="text"
                            inputMode="decimal"
                            autoComplete="off"
                            placeholder="0,00"
                            value={bulkPercent}
                            onChange={(e) => handleBulkPercentChange(e.target.value)}
                            onFocus={(e) => { setFocusedInput('bulk'); e.target.select(); }}
                            onBlur={handleBulkPercentBlur}
                            style={{
                                width: "96px",
                                padding: "8px 28px 8px 10px",
                                border: `1.5px solid ${isBulkInvalid
                                    ? "#ef4444"
                                    : focusedInput === 'bulk'
                                        ? "#0d9488"
                                        : bulkPercent
                                            ? "#0d9488"
                                            : "#cbd5e1"
                                    }`,
                                borderRadius: "8px",
                                fontSize: "14px",
                                fontWeight: 600,
                                background: isBulkInvalid ? "#fef2f2" : "#fff",
                                outline: "none",
                                textAlign: "right",
                                transition: "border-color 0.15s, box-shadow 0.15s",
                                boxShadow: focusedInput === 'bulk'
                                    ? "0 0 0 3px rgba(13,148,136,0.15)"
                                    : isBulkInvalid
                                        ? "0 0 0 3px rgba(239,68,68,0.12)"
                                        : "none",
                                color: isBulkInvalid ? "#dc2626" : "#1e293b",
                            }}
                        />
                        <span style={{
                            position: "absolute",
                            right: "8px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            fontSize: "12px",
                            fontWeight: 700,
                            color: isBulkInvalid ? "#ef4444" : "#94a3b8",
                            pointerEvents: "none",
                            userSelect: "none",
                        }}>%</span>
                    </div>
                </div>
                {isBulkInvalid && (
                    <div style={{ fontSize: "10.5px", color: "#dc2626", marginTop: "3px", fontWeight: 600 }}>
                        Entre 0,00 e 100,00
                    </div>
                )}
            </div>

            <button
                onClick={handleApplyBulkPercent}
                disabled={selectedCount === 0 || isBulkInvalid || !bulkPercent.trim()}
                style={{
                    background: (selectedCount > 0 && !isBulkInvalid && bulkPercent.trim()) ? "#0d9488" : "#cbd5e1",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "9px 15px",
                    fontSize: "13px",
                    fontWeight: 600,
                    cursor: (selectedCount > 0 && !isBulkInvalid && bulkPercent.trim()) ? "pointer" : "not-allowed",
                }}
            >
                Aplicar aos {selectedCount} selecionados
            </button>

            <span style={{ fontSize: "11.5px", color: "#94a3b8" }}>Valores entre 0,00 e 100,00.</span>
        </div>
    );
};
